import React from 'react';
import PropTypes from 'prop-types';
import ChatTabComponent from '~/pages/Dispatch/DispatchControl/ChatTab';

const ChatTab = ({
  equipment, classes,
}) => {
  if (!equipment || !equipment.id_equip) return null;

  return (
    <div className={classes.wrapperChat}>
      <ChatTabComponent selectedChatId={equipment.id_equip} />
    </div>
  );
};

export default ChatTab;

ChatTab.propTypes = {
  equipment: PropTypes.object.isRequired,
  classes: PropTypes.object.isRequired,
};
